import React, { useMemo, useState } from 'react'
import { Table, Button } from 'antd'
import moment from 'moment'
import ConfirmModal from '../../../common/Confirmation'

const ApplicantsTable = ({ data, onDelete }) => {
  const [confirmStep, setConfirmStep] = useState(0)
  const [pendingRecord, setPendingRecord] = useState(null)

  const handleDeleteClick = record => {
    setPendingRecord(record)
    setConfirmStep(1)
  }

  const handleFirstConfirm = () => setConfirmStep(2)

  const handleCancel = () => {
    setConfirmStep(0)
    setPendingRecord(null)
  }

  const handleFinalConfirm = () => {
    onDelete(pendingRecord.xp_key)
    setConfirmStep(0)
    setPendingRecord(null)
  }

  const columns = useMemo(() => [
    {
      title: '№',
      render: (_, __, index) => index + 1,
      width: 50,
    },
    {
      title: 'ФИО',
      dataIndex: 'fio',
      sorter: (a, b) => (a.fio || '').trim().localeCompare((b.fio || '').trim()),
    },
    {
      title: 'Дата рождения',
      dataIndex: 'birthDate',
      render: value => value ? moment(value, 'DD.MM.YYYY HH:mm:ss').format('DD.MM.YYYY') : '',
    },
    {
      title: 'Образовательная организация',
      dataIndex: 'orgName',
    },
    {
      title: 'Дата подачи заявки',
      dataIndex: 'applicantDate',
      sorter: (a, b) => moment(a.applicantDate, 'DD.MM.YYYY HH:mm:ss') - moment(b.applicantDate, 'DD.MM.YYYY HH:mm:ss'),
    },
    {
      title: '',
      render: (_, record) => (
        <Button danger size='small' onClick={() => handleDeleteClick(record)}>
          Удалить
        </Button>
      ),
      width: 90,
    },
  ], [])

  return (
    <>
      <Table
        bordered
        size='small'
        columns={columns}
        dataSource={data}
        rowKey={(_, index) => index}
        pagination={false}
      />
      <ConfirmModal
        isOpen={confirmStep === 1}
        title='Удалить?'
        text=''
        confirmText='Да'
        cancelText='Нет'
        onConfirm={handleFirstConfirm}
        onCancel={handleCancel}
      />
      <ConfirmModal
        isOpen={confirmStep === 2}
        title='Внимание'
        text={`Запись "${pendingRecord?.fio}" будет удалена безвозвратно, восстановить данные будет невозможно. Вы уверены?`}
        confirmText='Да'
        cancelText='Нет'
        onConfirm={handleFinalConfirm}
        onCancel={handleCancel}
      />
    </>
  )
}

export default ApplicantsTable
